import { render, staticRenderFns } from "./viewJUSTF.vue?vue&type=template&id=3ef2a56c&scoped=true"
import script from "./viewJUSTF.vue?vue&type=script&lang=js"
export * from "./viewJUSTF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef2a56c",
  null
  
)

export default component.exports